import { advogados } from './advogados'
import { atendimento } from './atendimento'
import { clinicas } from './clinicas'
import { contadores } from './contadores'
import { corretor } from './corretor'
import { financeiro } from './financeiro'
import { pequenosNegocios } from './pequenosNegocios'
import { professores } from './professores'
import { rh } from './rh'
import { secretaria } from './secretaria'
import { secretariaEscolar } from './secretariaEscolar'
import type { ProfessionPageConfig } from './types'
import { vendedores } from './vendedores'

/**
 * As doze profissões aprovadas por Arthur em 12/09/2026, na ordem em que
 * aparecem no sitemap. Cada uma vira uma página em /ia-para-.../ com a mesma
 * moldura (ProfessionPage) e a mesma ficha JSON-LD.
 */
export const professions: readonly ProfessionPageConfig[] = Object.freeze([
  corretor,
  secretaria,
  contadores,
  advogados,
  professores,
  secretariaEscolar,
  clinicas,
  vendedores,
  rh,
  financeiro,
  atendimento,
  pequenosNegocios,
])
